@if (!editMode) {
  <button mat-menu-item id="add-saved-search" class="flex-centered" [disabled]="disabled" (click)="show()">
    <mat-icon>bookmark_add</mat-icon>
    <span>{{ 'watson.saved.search.add' | translate }}</span>
  </button>
}

@if (savedSearch && !editMode) {
  <button mat-menu-item id="save-saved-search" class="flex-centered" [disabled]="disabled" (click)="update()">
    <mat-icon>bookmark</mat-icon>
    <span>{{ 'watson.saved.search.save' | translate }}</span>
  </button>
}

@if (savedSearch && editMode) {
  <button mat-menu-item id="edit-saved-search" class="flex-centered" [disabled]="disabled" (click)="show()">
    <mat-icon>edit</mat-icon>
    <span>{{ 'commons.btn.edit' | translate }}</span>
  </button>
}

<ng-template #addSavedSearch>
  <header mat-dialog-title>
    <h1>
      <span>{{ (editMode ? 'watson.saved.search.dlg.edit.title' : 'watson.saved.search.add') | translate }}</span>
      @if (!editMode) {
        <mat-icon>bookmark_add</mat-icon>
      }
      @if (editMode) {
        <mat-icon>bookmark</mat-icon>
      }
    </h1>
  </header>
  <section mat-dialog-content>
    <form [formGroup]="form">
      <app-form-field-text
        [formGroup]="form"
        [errors]="[
          { error: 'required', messageKey: 'commons.validations.required' },
          { error: 'maxlength', messageKey: 'commons.validations.maxLength' },
          { error: 'duplicate', messageKey: 'commons.validations.duplicate' },
        ]"
        label="commons.labels.name"
        field="name"
        type="text"
        >
      </app-form-field-text>
    </form>
  </section>
  <footer mat-dialog-actions align="end">
    <button id="cancel-btn" mat-button (click)="cancelDialog()">
      {{ 'commons.btn.cancel' | translate }}
    </button>
    @if (editMode) {
      <button id="save-btn" mat-raised-button color="primary" (click)="closeDialog()" [disabled]="!form.valid || savedSearch.name === form.controls['name'].value">
        {{ 'commons.btn.save' | translate }}
      </button>
    }
    @if (!editMode) {
      <button id="add-btn" mat-raised-button color="primary" (click)="closeDialog()" [disabled]="!form.valid">
        {{ 'commons.btn.add' | translate }}
      </button>
    }
  </footer>
</ng-template>
